import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

// Rete di sicurezza globale: cattura qualunque eccezione di render dell'albero
// figlio e mostra una card di recupero invece della schermata bianca (che
// rendeva l'app inutilizzabile finché non si ricaricava a mano).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary ha catturato un errore di render:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-svh flex items-center justify-center bg-gray-50 p-4">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 max-w-md w-full text-center">
          <div className="w-12 h-12 rounded-xl bg-rose-100 text-rose-600 flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <h1 className="text-lg font-bold text-gray-900">Qualcosa è andato storto</h1>
          <p className="text-sm text-gray-600 mt-2">
            La pagina ha riscontrato un errore imprevisto. Ricarica per riprovare.
          </p>
          <details className="mt-3 text-left">
            <summary className="text-xs text-gray-500 cursor-pointer hover:text-gray-700">Dettagli tecnici</summary>
            <pre className="mt-2 text-[11px] font-mono bg-gray-50 border border-gray-200 rounded-lg p-2 overflow-auto max-h-40 whitespace-pre-wrap break-all">
              {String(this.state.error?.message || this.state.error)}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 w-full bg-[#48484A] text-white rounded-xl py-2 text-sm font-semibold hover:bg-[#3A3A3C] transition-colors"
          >
            Ricarica la pagina
          </button>
        </div>
      </div>
    );
  }
}
